import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import user1 from "../../../assets/images/users/avatar-1.jpg";

const ProfileMenu = (props) => {
  const [menu, setMenu] = useState(false);
  const [username, setusername] = useState("Admin");

  useEffect(() => {
    const authUser = localStorage.getItem("authUser");
    if (authUser && authUser !== "undefined" && authUser !== "null") {
      try {
        const obj = JSON.parse(authUser);
        if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
          setusername(obj.displayName);
        } else if (
          process.env.REACT_APP_DEFAULTAUTH === "fake" ||
          process.env.REACT_APP_DEFAULTAUTH === "jwt"
        ) {
          setusername(obj.username);
        }
      } catch (error) {
        console.error("Error parsing authUser:", error);
        setusername("Admin");
      }
    }
  }, [props.success]);

  // Inline Styles
  const dropdownToggleStyle = {
    background: "transparent",
    border: "none",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    gap: "0.3rem",
    padding: "0.2rem 0.4rem",
    transition: "all 0.3s ease",
    color: "inherit",
    cursor: "pointer",
  };

  const avatarStyle = {
    width: "32px",
    height: "32px",
    border: "2px solid rgba(0, 0, 0, 0.2)",
    borderRadius: "50%",
    transition: "all 0.3s ease",
  };

  const usernameStyle = {
    fontSize: "0.85rem",
    fontWeight: 500,
    color: "inherit",
  };

  const dropdownMenuStyle = {
    background: "#ffffff",
    borderRadius: "10px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
    padding: "0.3rem 0",
    minWidth: "160px",
  };

  const dropdownItemStyle = {
    display: "flex",
    alignItems: "center",
    gap: "0.4rem",
    padding: "0.4rem 0.8rem",
    fontWeight: 500,
    fontSize: "0.85rem",
    color: "#495057",
    cursor: "pointer",
    transition: "all 0.2s ease",
  };

  const dropdownItemHover = {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "#ffffff",
    transform: "translateX(3px)",
  };

  return (
    <Dropdown
      isOpen={menu}
      toggle={() => setMenu(!menu)}
      className="d-inline-block"
    >
      <DropdownToggle style={dropdownToggleStyle}>
        <img
          src={user1}
          alt="Header Avatar"
          style={avatarStyle}
        />
        <span style={usernameStyle} className="d-none d-xxl-inline-block ms-1">
          {username}
        </span>
        <i className="mdi mdi-chevron-down d-none d-xxl-inline-block" style={{ fontSize: "0.9rem" }} />
      </DropdownToggle>

      <DropdownMenu style={dropdownMenuStyle} className="dropdown-menu-end">
        <DropdownItem tag="a" href="/profile" style={dropdownItemStyle}>
          <i className="bx bx-user" style={{ fontSize: "0.95rem" }} />
          {props.t("Profile")}
        </DropdownItem>

        <DropdownItem tag="a" href="#" style={dropdownItemStyle}>
          <i className="bx bx-wrench" style={{ fontSize: "0.95rem" }} />
          {props.t("Settings")}
        </DropdownItem>

        <div className="dropdown-divider" style={{ margin: "0.3rem 0" }} />

        <Link to="/logout" style={{ ...dropdownItemStyle, color: "#ff3b3b" }}>
          <i className="bx bx-power-off" style={{ fontSize: "0.95rem" }} />
          <span>{props.t("Logout")}</span>
        </Link>
      </DropdownMenu>
    </Dropdown>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
